import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SITE } from "@/lib/site";

const storeUrl = () => {
  const sts = SITE.products.safeToSpend;
  const ua = navigator.userAgent || "";
  if (/android/i.test(ua)) return sts.playStoreUrl;
  return sts.appStoreUrl;
};

export default function StartFreeButton() {
  const { t } = useTranslation("products");
  return (
    <a
      href={SITE.products.safeToSpend.appStoreUrl}
      onClick={(e) => {
        e.preventDefault();
        window.open(storeUrl(), "_blank", "noopener,noreferrer");
      }}
      data-testid="sts-plan-free-start-button"
      className="group mt-7 flex w-full items-center justify-center gap-2 rounded-full bg-[#00C48C] px-6 py-3 text-[15px] font-semibold text-[#0A1128] hover:bg-[#00A373] hover:text-white active:scale-[0.98] transition-[background-color,color,transform]"
    >
      {t("sts.pricing.startFree")}
      <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
    </a>
  );
}
